import classNames from 'classnames/bind';
import styles from '@/styles/superstack/companies/CardCompanyStacks.module.scss';
const cx = classNames.bind(styles);

import SSImage from '@/src/component/superstack/base/SSImage';
import CompanyLogoDefault from '@/asset/superstack/svgs/company-logo-default.svg';
import StackImage from '@/src/component/superstack/stacks/StackImage';
import { STACK_CATEGORY_KOR_MAP } from '@/src/utils/superstack/stacks';
import * as _ from 'lodash';
import { useRecoilValue } from 'recoil';
import { mobileState } from '@/src/utils/hooks/useMobileSize';
import useCompanyJobs from '@/src/utils/hooks/superstack/useCompanyJobs';
import { StacksLinks } from '@/data/superstack/StackLinks';

const CardCompanyStacks = ({ company }) => {
  const { data: { data: jobs = [] } = {} } = useCompanyJobs(company.id);
  const isMobile = useRecoilValue(mobileState);
  const stacksCompanyUrl = StacksLinks(company.id).find((url) => url.name === 'stacks_company').url;

  if (!company?.company_stacks) {
    return null;
  }
  const logoImg = company?.logo ? (
    <SSImage src={company.logo} width={48} height={48} objectFit={'contain'} />
  ) : (
    <CompanyLogoDefault width={48} height={48} />
  );
  const categoryCounter = _.countBy(
    company.company_stacks.map((stack) => {
      return stack.category;
    }),
  );
  const sortedCounter = Object.entries(categoryCounter)
    .sort(([, a], [, b]) => b - a)
    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
  const mostCountedCategories = Object.entries(sortedCounter)
    .slice(0, 2)
    .map(([category, cnt]) => {
      return `${STACK_CATEGORY_KOR_MAP.get(category)} ${cnt}개`;
    });

  const size = isMobile ? 22 : 24;
  return (
    <a href={stacksCompanyUrl} className={cx('card')}>
      <div className={cx('head')}>
        <div className={cx('name-wrapper')}>
          <p className={cx('name')}>{company.name}</p>
          <p className={cx('subtitle')}>총 {company.company_stacks.length}개의 기술 스택</p>
        </div>
        <div className={cx('logo-wrapper')}>{logoImg}</div>
      </div>
      <section className={cx('stacks')}>
        {company?.company_stacks &&
          company.company_stacks.map((stack) => {
            return (
              <span key={stack.flag} className={cx('stack-wrapper')}>
                <StackImage width={size} height={size} flag={stack.flag} alt={stack.name} />
              </span>
            );
          })}
      </section>
      <div className={cx('summary')}>
        <span>{mostCountedCategories.join(', ')}</span>
      </div>
      {jobs.length > 0 && (
        <div className={cx('summary')} style={{ marginTop: '10px', backgroundColor: '#fafafa' }}>
          <span>채용 중!</span>
        </div>
      )}
    </a>
  );
};

export { CardCompanyStacks };
